//Import React Hooks
import { useEffect, useState } from 'react'

//MUI :
import Button from '@mui/material/Button';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import MobileStepper from '@mui/material/MobileStepper';
import CloseIcon from '@mui/icons-material/Close';
import HelpIcon from '@mui/icons-material/Help';
import Alert from '@mui/material/Alert';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import TaskAltIcon from '@mui/icons-material/TaskAlt';
import SyncIcon from '@mui/icons-material/Sync';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';

import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';

function TutoModal({ toStep, handleClose }) {

    const [step, setStep] = useState(toStep);
    let maxStep = 8;

    function previousStep() {
        setStep(step - 1);
    }
    function nextStep() {
        setStep(step + 1);
    }


    return (
        <div className="home-resa-modal-content">
            <div className="home-resa-modal-content-top">
                {/* <Button
                            variant="contained"
                            size="small"
                            onClick={_ => handleClose()}>
                            J'ai compris <ThumbUpIcon />
                        </Button> */}
                <span onClick={_ => handleClose()}>
                    <CloseIcon />
                </span>
            </div>
            <div className="home-resa-modal-content-middle">

                {/* {step === 1 ?
                    <div className="home-resa-modal-content-middle-step1">
                        <p>Cette présentation courte et ludique explique les formalités de pré-réservation en ligne pour <b>son cours</b> ou <b>son stage</b> de surf pour <b>une ou plusieurs personnes.</b></p>
                    </div>
                    : null}
                {step === 2 ?
                    <div className="home-resa-modal-content-middle-step2">
                        <p>Tu commences à bien nous connaitre&#128512;, voilà pourquoi Wally glisse et son staff se réservent le droit de valider ou non les sessions de 2 heures <b>en fonction des conditions météo et de marées.</b></p>
                    </div>
                    : null}
                {step === 3 ?
                    <div className="home-resa-modal-content-middle-step3">
                        <p>Notre ambition est simple : te faire pratiquer notre sport <b>dans les meilleures conditions possible</b> en évitant les mauvaises surprises.</p>
                    </div>
                    : null} */}
                {step === 1 ?
                    <div className="home-resa-modal-content-middle-step step1">
                        <p>Comment ça marche?</p>
                        <Alert severity="info">Ce guide sera accessible en permanence tout au long de votre demande, en cliquant sur l'icone <HelpIcon /> en haut à droite de la fenêtre</Alert>
                        <p>A chaque étape de la pré-réservation, il y'aura ces 2 boutons tout en bas de la fenêtre : <br /> Soit pour valider tes choix et passer à la suite.<br />Soit pour revenir modifier certaines informations.</p>
                        <img src={require("../../images/screenshots/screenshot-step1-1.jpg")} alt="screenshot appli" />
                    </div>
                    : null}
                {step === 2 ?
                    <div className="home-resa-modal-content-middle-step step2">
                        <p>Comment ça marche?</p>
                        <p>Si tu es déjà un Wally rider, <b>si tu as déjà réservé des cours via cette appli</b>, tu peux rentrer ton numéro de téléphone pour que l'on <b>te retrouve, ainsi que les élèves pour qui tu as déjà réservé.</b></p>
                        {/* <div className="step2-zone1">
                            <img src={require("../../images/screenshots/screenshot-step2-1.jpg")} alt="screenshot appli" />
                            <ArrowForwardIcon />
                            <img src={require("../../images/screenshots/screenshot-step2-2.jpg")} alt="screenshot appli" />

                        </div> */}
                        <p>Si c'est ta première réservation, tu peux directement choisir <b>"Réservez vos sessions"</b>.</p>
                        {/* <div className="step2-zone2">
                            <img src={require("../../images/screenshots/screenshot-step2-3.jpg")} alt="screenshot appli" />
                        </div> */}
                    </div>
                    : null}
                {step === 3 ?
                    <div className="home-resa-modal-content-middle-step step3">
                        <p><b>Sélectionne les élèves</b> pour qui tu veux (à nouveau) réserver, ou <b>ajoutes en des nouveaux.</b></p>
                        <img src={require("../../images/screenshots/screenshot-step3-1.jpg")} alt="screenshot appli" />
                        <p>Pour chaque élève, il faudra renseigner :</p>
                        <ul>
                            <li>Son prénom</li>
                            <li>Son âge</li>
                            <li>Son niveau de surf</li>
                            <li>Sa "fidélité" à Wally Glisse</li>
                        </ul>
                        <img src={require("../../images/screenshots/screenshot-step3-2.jpg")} alt="screenshot appli" />
                    </div>
                    : null}
                {step === 4 ?
                    <div className="home-resa-modal-content-middle-step step4">
                        <p>Sélectionne, <b>sur le calendrier interactif</b>, les sessions auxquelles chaque élève souhaite participer.</p>
                        <img src={require("../../images/screenshots/screenshot-step4-1.jpg")} alt="screenshot appli" />
                        <p>Pour chaque élève, <b>la formule tarifaire est automatiquement calculée</b> en fonction du nombre de sessions selectionnées. Le tarif des formules inclus tout le matériel nécessaire et l'assurance de la fédération française de surf. </p>
                        <img src={require("../../images/screenshots/screenshot-step4-2.jpg")} alt="screenshot appli" />

                    </div>
                    : null}
                {step === 5 ?
                    <div className="home-resa-modal-content-middle-step step5">
                        <p>Sur le calendrier interactif, il est possible d'afficher et de modifier les informations concernant chaque élève.</p>
                        <img src={require("../../images/screenshots/screenshot-step5-1.jpg")} alt="screenshot appli" />

                        <p><b>Il existe plusieurs manières de sélectionner et modifier les sessions pour chaque élève :</b></p>
                        <p>- Cliquer sur un créneau du planning et sélectionner les élèves participant à ce créneau.</p>
                        <img src={require("../../images/screenshots/screenshot-step5-2.jpg")} alt="screenshot appli" />
                        <p>- Ajouter une nouvelle session pour un élève (il est possible d'ajouter d'autres élèves en même temps).</p>
                        <img src={require("../../images/screenshots/screenshot-step5-3.jpg")} alt="screenshot appli" />
                        <p>- Supprimer ou déplacer une session pour un élève, en modifiant la date et/ou l'horaire de session.</p>
                        <img src={require("../../images/screenshots/screenshot-step5-4.jpg")} alt="screenshot appli" />


                    </div>
                    : null}

                {step === 6 ?
                    <div className="home-resa-modal-content-middle-step step6">
                        <p>Avant de nous envoyer ta demande, vérifie une dernière fois les infos concernant les élèves et les sessions sélectionnées.</p>
                        <img src={require("../../images/screenshots/screenshot-step6-1.jpg")} alt="screenshot appli" />
                        <p>Tu as la possibilité de nous laisser <b>un message dans le champ "commentaire"</b> pour compléter les infos fournies.</p>

                    </div>
                    : null}

                {step === 7 ?
                    <div className="home-resa-modal-content-middle-step step7">
                        <SyncIcon />
                        <p>Ta demande va nous parvenir, et, si le Wally planning et les conditions de surf matchent, <b>let’s Go surfing…</b></p>
                        <ForwardToInboxIcon />
                        <p>tu recevras une notification par mail dès que ta pré-réservation est validée <b>ou</b> une proposition du Wally Staff pour un autre session sur un autre créneau horaire.</p>

                        <TaskAltIcon />
                        <p>Une fois la demande de réservation validée, le règlement pourra se faire, soit immédiatement par paiement en ligne, soit sur place en espèces, par chèque, ou chèque vacances.</p>

                    </div>
                    : null}
                {step === 8 ?
                    <div className="home-resa-modal-content-middle-step step8">

                        <Button
                            className="home-resa-next-bouton"
                            variant="contained"
                            onClick={_ => handleClose()}>
                            J'ai compris, quitter le guide
                        </Button>

                    </div>
                    : null}


            </div>
            <div className="home-resa-modal-content-bottom">

                <MobileStepper
                    variant="progress"
                    steps={maxStep + 1}
                    position="static"
                    activeStep={step}
                    sx={{ maxWidth: 600, flexGrow: 1 }}
                    nextButton={
                        <Button size="small" onClick={_ => nextStep()} disabled={step === maxStep}>
                            Suivant
          <KeyboardArrowRight />
                        </Button>
                    }
                    backButton={
                        <Button size="small" onClick={_ => previousStep()} disabled={step === 1}>
                            <KeyboardArrowLeft />
          Retour
        </Button>
                    }
                />

                {/*  <Button
                            variant="contained"
                            size="small"
                            disabled={step === 1}
                            onClick={_ => previousStep()}>
                            <SkipPreviousIcon />
                        </Button>

                        <Button
                            variant="contained"
                            size="small"
                            disabled={step === maxStep}
                            onClick={_ => nextStep()}>
                            <SkipNextIcon />
                        </Button> */}

            </div>
        </div>

    );
}

export default TutoModal;